module.exports = __webpack_public_path__ + "static/media/Tollinton-Market,-The-Mall.1f41ad5f.jpg";